module.exports = "#app-root {\n  height: 100%;\n  width: 100%; }\n  #app-root[theme=dark] {\n    background-color: #252525; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.scss
// module id = ./src/app/app.component.scss
// module chunks = main